import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { SplashScreenService } from '@clean-code/shared/common';
import { environment } from '../environments/environment';
import { NotificationService } from '@clean-code/notifications/domain';
import { RegisterUserLimitViolationNotificationType } from '@clean-code/user-limit/ui-violation-notification';
import {
  RegisterBuySignalNotificationType,
  RegisterLimitReportPowerSignalNotificationType,
  RegisterLimitReportGasSignalNotificationType,
  RegisterLimitReportOtherSignalNotificationType,
} from '@backoffice-frontend/limit-report/notification/ui-buysignalnotification';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'backoffice-frontend-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [AsyncPipe, RouterModule]
})
export class AppComponent {
  private splashState = inject(SplashScreenService);
  public showSplash$ = this.splashState.showSplash$;

  constructor() {
    const titleService = inject(Title);
    const notificationService = inject(NotificationService);
    RegisterUserLimitViolationNotificationType(notificationService);
    RegisterBuySignalNotificationType(notificationService);
    RegisterLimitReportPowerSignalNotificationType(notificationService);
    RegisterLimitReportGasSignalNotificationType(notificationService);
    RegisterLimitReportOtherSignalNotificationType(notificationService);

    titleService.setTitle(environment.name);
  }
}
